__turbopack_context__.v({
  "boundaryMeta": "TripOverviewStops-module__Oy128G__boundaryMeta",
  "card": "TripOverviewStops-module__Oy128G__card",
  "count": "TripOverviewStops-module__Oy128G__count",
  "dates": "TripOverviewStops-module__Oy128G__dates",
  "error": "TripOverviewStops-module__Oy128G__error",
  "icon": "TripOverviewStops-module__Oy128G__icon",
  "iconHome": "TripOverviewStops-module__Oy128G__iconHome",
  "list": "TripOverviewStops-module__Oy128G__list",
  "loadingBar": "TripOverviewStops-module__Oy128G__loadingBar",
  "meta": "TripOverviewStops-module__Oy128G__meta",
  "name": "TripOverviewStops-module__Oy128G__name",
  "nameLink": "TripOverviewStops-module__Oy128G__nameLink",
  "nights": "TripOverviewStops-module__Oy128G__nights",
  "row": "TripOverviewStops-module__Oy128G__row",
  "stepButton": "TripOverviewStops-module__Oy128G__stepButton",
  "stepper": "TripOverviewStops-module__Oy128G__stepper",
});
